import { render, staticRenderFns } from "./EditComplaint.vue?vue&type=template&id=120efb56&"
import script from "./EditComplaint.vue?vue&type=script&lang=js&"
export * from "./EditComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports